import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Breadcrumb, Button, Card, Dropdown, Icon, Menu, Modal, message } from 'antd';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { s3Host } from '../../../utils';
import dragImage from '../../../assets/images/drag-reorder.png';
import placeholderImage from "../../../assets/images/placeholder.png";

import { Form } from '../../../components';
import PageHeaderLayout from '../../../layouts/PageHeaderLayout';
import { Category } from '../../../models';
import styles from './index.less';

const { confirm } = Modal;

const PopoverContent = ({
  onEdit, onDelete, item, col, idx,
}) => (
  <Menu>
    <Menu.Item>
      <a onClick={() => onEdit(item)}><Icon type="edit" /> Засах</a>
    </Menu.Item>
    {
      item.count === 0 ? (
        <Menu.Item>
          <a onClick={() => onDelete({ item, col, idx })}><Icon type="delete" /> Устгах</a>
        </Menu.Item>) : null
    }
  </Menu>
);

PopoverContent.propTypes = {
  col: PropTypes.number.isRequired,
  idx: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const PopoverHandle = ({
  onEdit, onDelete, item, col, idx,
}) => (
  <Dropdown
    placement="topRight"
    overlay={PopoverContent({
      onDelete, onEdit, item, col, idx,
    })}
    trigger={['click']}
  >
    <Icon style={{ cursor: 'pointer' }} type="ellipsis" />
  </Dropdown>
);

PopoverHandle.propTypes = {
  col: PropTypes.number.isRequired,
  idx: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const DragHandle = SortableHandle(() => (
  <div className={styles.handle}>
    <img src={dragImage} width="20" alt="" />
  </div>
));

const SortableItem = SortableElement(({
  item, idx, col, onClick, isActive,
  onEdit, onDelete,
}) => (
  <div
    className={`${styles.stylizedItem} ${isActive ? styles.active : ''}`}
  >
    <div className={styles.catItem} onClick={() => onClick({ item, idx, col })}>
      <div className={styles.cardImageContainer}>
        {item.image ?
          <img src={`${s3Host}${item.image}`} width="100%" alt={item.alias} />
          :
          <img className={styles.placeholder} src={placeholderImage} height="100%" alt={item.alias} />
        }
      </div>
      <div className={styles.catContent}>
        <div className={styles.catTitle}>
          {item.alias} {item.count ? `(${item.count})` : null}
        </div>
      </div>
    </div>
    <div className={styles.catAction}>
      <PopoverHandle onEdit={onEdit} item={item} onDelete={onDelete} col={col} idx={idx} />
      <DragHandle />
    </div>
  </div>
));


const SortableList = SortableContainer(({
  items, col, onClick, onEdit, onDelete, activeIndex, parentIndex, onCreate,
}) => (
  <div>
    <div className={styles.action}>
      <Button onClick={() => onCreate({ col, parentIndex })} icon="plus">Нэмэх</Button>
    </div>
    <div className={styles.stylizedList}>
      {items.map((item, index) => (
        <SortableItem
          key={`item-${index}`}
          col={col}
          index={index}
          idx={index}
          item={item}
          onClick={onClick}
          onEdit={onEdit}
          isActive={activeIndex === index}
          onDelete={onDelete}
        />
      ))}
    </div>
  </div>

));

class CategoryList extends Component {
  static propTypes = {
    loadCategory: PropTypes.func.isRequired,
    thisCat: PropTypes.object.isRequired,
    changeOrder: PropTypes.func.isRequired,
    delete: PropTypes.func.isRequired,
    create: PropTypes.func.isRequired,
    update: PropTypes.func.isRequired,
    changeOrderAsync: PropTypes.func.isRequired,
    categories: PropTypes.array,
  }

  static defaultProps = {
    categories: [],
  }

  constructor(props) {
    super(props);
    this.state = {
      firstIndex: null,
      secondIndex: null,
      thirdIndex: null,
      col: 1,
      formModal: false,
      formData: {},
      updateToggle: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.updateToggle !== nextState.updateToggle) {
      console.log('triggered');
      return false;
    }
    return true;
  }

  onSortEnd = async ({ col, oldIndex, newIndex }) => {
    await this.props.changeOrder({
      col,
      oldIndex,
      newIndex,
      firstIndex: this.state.firstIndex,
      secondIndex: this.state.secondIndex,
      thirdIndex: this.state.thirdIndex,
    });

    let ordered = [];
    let calculated = -1;
    console.log('this.props.categories: ', this.props.categories);
    switch (col) {
      case 1:
        ordered = this.props.categories.map(entry => entry.id);
        console.log({ ordered });
        calculated = this.calculateIndex({ currentIndex: this.state.firstIndex, oldIndex, newIndex });
        if (calculated !== -1) {
          this.setState(() => (
            { firstIndex: calculated }
          ));
        }
        break;
      case 2:
        ordered = this.props.categories[this.state.firstIndex].relations.map(entry => entry.id);
        calculated = this.calculateIndex({ currentIndex: this.state.secondIndex, oldIndex, newIndex });
        if (calculated !== -1) {
          this.setState(() => (
            { secondIndex: calculated }
          ));
        }
        break;
      case 3:
        ordered = this.props.categories[this.state.firstIndex].relations[this.state.secondIndex].relations.map(entry => entry.id);
        calculated = this.calculateIndex({ currentIndex: this.state.thirdIndex, oldIndex, newIndex });
        if (calculated !== -1) {
          this.setState(() => (
            { thirdIndex: calculated }
          ));
        }
        break;
      default:
        ordered = this.props.categories.map(entry => entry.id);
        break;
    }

    await this.props.changeOrderAsync({ body: { ids: ordered } });
  }

  onEdit = (item) => {
    console.log('item: ', item);
    const { relations, relation_id: camel, ...formData } = item;

    formData.relation_id = camel === null ? 0 : camel;

    this.setState({
      formModal: true,
      formData,
    });
  }

  onDelete = ({ item, col, idx }) => {
    console.log({ col, idx });
    confirm({
      title: `Анхаар`,
      content: `Tа яг одоо " ${item.alias} " категорийг устгах гэж байна.`,
      okText: 'Тийм',
      okType: 'danger',
      cancelText: 'Үгүй',
      onOk: async () => {
        await this.props.delete({ body: { id: item.id } });
        console.log('this.props.thisCat: ', this.props.thisCat);
        if (this.props.thisCat.error) return message.error('Энэ категорийг устгахын тулд хүүхэд категорийг эхлээд устгана уу!');
        this.calculateDelete(col, idx);
        await this.refresh();
        return true;
      },
      onCancel: () => {
        console.log('Үгүй');
      },
    });
  }

  onCreate = ({ parentIndex }) => {
    this.setState({
      formModal: true,
      formData: {
        relation_id: parentIndex,
      },
    });
  }

  getFormOption = () => (
    {
      schema: {
        title: 'Form',
        type: 'object',
        required: ['relation_id', 'alias'],
        column: 12,
        properties: {
          relation_id: {
            type: 'number',
            label: 'Категори',
            options: this.props.categories,
          },
          alias: {
            type: 'string',
            placeholder: 'Категори нэр оруулна',
            label: 'Категори нэр',
          },
          alias_checker: {
            type: 'string',
            placeholder: 'Excel-ээс татах категори нэр',
            label: 'Excel-ээс татах категори нэр',
          },
          image: {
            type: 'string',
            label: 'Зураг',
          },
          active: {
            type: 'boolean',
            label: 'Идэвхтэй эсэх',
            placeholder: 'Тийм',
          },
        },
      },
      uiSchema: {
        relation_id: {
          "ui:widget": "nested-select",
          "ui:disabled": Number.isInteger(this.state.formData.id),
        },
        alias: {
          "ui:widget": "input",
          "ui:placeholder": "Категори нэр оруулна",
        },
        alias_checker: {
          "ui:widget": "input",
          "ui:placeholder": "Excel-ээс татах категори нэр оруулна",
        },
        image: {
          "ui:widget": "single-image",
        },
        active: {
          "ui:widget": "switch-active",
        },
      },
    }
  )
  calc = (idx, activeIdx) => {
    if (!activeIdx && activeIdx !== 0) return false;
    if (idx === activeIdx) return null;
    if (activeIdx > idx) return activeIdx - 1;
    return false;
  }

  calculateDelete = (col, idx) => {
    let returnObject = {};

    switch (col) {
      case 1: {
        const checker = this.calc(idx, this.state.firstIndex);
        if (checker !== false) {
          if (checker === null) {
            returnObject = {
              firstIndex: null,
              secondIndex: null,
              thirdIndex: null,
              col: 1,
            };
          } else {
            returnObject = { firstIndex: checker };
          }
        }
        break;
      }
      case 2: {
        const checker = this.calc(idx, this.state.secondIndex);
        if (checker !== false) {
          if (checker === null) {
            returnObject = {
              secondIndex: null,
              thirdIndex: null,
              col: 1,
            };
          } else {
            returnObject = { secondIndex: checker };
          }
        }
        break;
      }
      case 3: {
        const checker = this.calc(idx, this.state.thirdIndex);
        if (checker !== false) {
          if (checker === null) {
            returnObject = {
              thirdIndex: null,
              col: 2,
            };
          } else {
            returnObject = { thirdIndex: checker };
          }
        }
        break;
      }
      default:
        break;
    }

    if (Object.keys(returnObject).length) {
      this.setState(() => ({
        ...returnObject,
        updateToggle: !this.state.updateToggle,
      }));
    }
  }

  formSubmit = () => {
    this.setState({
      formModal: false,
      formData: {},
    });
  }

  formCancel = () => {
    this.setState({
      formModal: false,
      formData: {},
    });
  }

  categorySubmit = async ({ formData }) => {
    let returnObj;

    if (!formData.relation_id) {
      const { relation_id: camel, ...rest } = formData;
      returnObj = rest;
    } else {
      returnObj = formData;
    }

    if (returnObj.id) {
      await this.props.update({ body: { ...returnObj } });
    } else {
      await this.props.create({ body: { ...returnObj } });
    }


    this.setState({
      formModal: false,
      formData: {},
    });
    this.refresh();
  }

  calculateIndex = ({ currentIndex, oldIndex, newIndex }) => {
    if (currentIndex < oldIndex && oldIndex <= newIndex) {
      return -1;
    } else if (currentIndex > oldIndex && oldIndex >= newIndex) {
      return -1;
    } else if (currentIndex === oldIndex) {
      return newIndex;
    } else if (currentIndex < oldIndex && currentIndex >= newIndex) {
      return currentIndex + 1;
    } else if (currentIndex > oldIndex && currentIndex <= newIndex) {
      return currentIndex - 1;
    }
    return -1;
  }

  breadcrumb = (
    <div className={styles.pageTop}>
      <Breadcrumb className={styles.Topbread}>
        <Breadcrumb.Item><Link to="/">Нүүр</Link></Breadcrumb.Item>
        <Breadcrumb.Item>Категори</Breadcrumb.Item>
      </Breadcrumb>
    </div>
  )

  categoryCard = (item, key, col, index) => (
    <div className={styles.cardItem} onClick={() => { this.handleClick(item, col, index); }} key={key}>
      <div className={styles.cardImageContainer}>
        <img src={placeholderImage} alt={item.alias} />
      </div>
      <div className={styles.cardLabelContainer}>
        {item.alias}
      </div>
      <div className={styles.cardQuantityContainer}>
        12
      </div>
    </div>
  )

  handleClick = ({
    col, idx,
  }) => {
    switch (col) {
      case 1: {
        this.setState({
          firstIndex: idx,
          secondIndex: null,
          thirdIndex: null,
          col,
        });
        break;
      }
      case 2: {
        this.setState({
          secondIndex: idx,
          thirdIndex: null,
          col,
        });
        break;
      }
      case 3: {
        this.setState({
          thirdIndex: idx,
          col,
        });
        break;
      }

      default:
        break;
    }
  }

  refresh = async () => {
    this.setState(() => (
      {
        formData: {},
        formModal: false,
      }
    ));
    await this.props.loadCategory();
  }

  formSubmit = () => {
    this.setState({
      formModal: false,
      formData: {},
    });
  }

  formCancel = () => {
    this.setState({
      formModal: false,
      formData: {},
    });
  }

  validate = (formData, errors) => {
    if (formData.image === 'loading') {
      errors.image.addError('Зураг хуулж дуусаагүй байна');
    }
    return errors;
  }

  render() {
    return (
      <PageHeaderLayout content={this.breadcrumb}>
        <Card bordered>
          <div className={styles.cardContainer}>
            <div className={styles.row}>
              <SortableList
                col={1}
                helperClass={`${styles.helper} ${styles.stylizedHelper}`}
                items={this.props.categories || []}
                onSortEnd={({ oldIndex, newIndex }) => this.onSortEnd({ col: 1, oldIndex, newIndex })}
                onClick={this.handleClick}
                onEdit={this.onEdit}
                onDelete={this.onDelete}
                onCreate={this.onCreate}
                activeIndex={this.state.firstIndex}
                parentIndex={0}
                useDragHandle
              />
            </div>
            <div className={styles.row}>
              {(this.state.firstIndex || (this.state.firstIndex === 0)) &&
                <SortableList
                  col={2}
                  items={(
                    this.props.categories[this.state.firstIndex] &&
                    this.props.categories[this.state.firstIndex].relations
                  ) || []}
                  onSortEnd={({ oldIndex, newIndex }) => this.onSortEnd({ col: 2, oldIndex, newIndex })}
                  onClick={this.handleClick}
                  onEdit={this.onEdit}
                  onDelete={this.onDelete}
                  onCreate={this.onCreate}
                  activeIndex={this.state.secondIndex}
                  parentIndex={this.state.firstIndex && this.props.categories[this.state.firstIndex].id}
                  useDragHandle
                />
              }
            </div>
            <div className={styles.row}>
              {(this.state.firstIndex || (this.state.firstIndex === 0)) && (this.state.secondIndex || (this.state.secondIndex === 0)) &&
                <SortableList
                  col={3}
                  helperClass={`${styles.helper} ${styles.stylizedHelper}`}
                  items={(
                    this.props.categories[this.state.firstIndex] &&
                    this.props.categories[this.state.firstIndex].relations &&
                    this.props.categories[this.state.firstIndex].relations[this.state.secondIndex] &&
                    this.props.categories[this.state.firstIndex].relations[this.state.secondIndex].relations
                  ) || []}
                  onSortEnd={({ oldIndex, newIndex }) => this.onSortEnd({ col: 3, oldIndex, newIndex })}
                  onClick={this.handleClick}
                  onEdit={this.onEdit}
                  onDelete={this.onDelete}
                  onCreate={this.onCreate}
                  activeIndex={this.state.thirdIndex}
                  parentIndex={
                    this.props.categories[this.state.firstIndex] &&
                    this.props.categories[this.state.firstIndex].relations &&
                    this.props.categories[this.state.firstIndex].relations[this.state.secondIndex] &&
                    this.props.categories[this.state.firstIndex].relations[this.state.secondIndex].id
                  }
                  useDragHandle
                />
              }
            </div>
            <div className={styles.row}>
              {(this.state.firstIndex || (this.state.firstIndex === 0)) && (this.state.secondIndex || (this.state.secondIndex === 0)) && (this.state.thirdIndex || (this.state.thirdIndex === 0)) &&
                <SortableList
                  col={4}
                  items={(
                      this.props.categories[this.state.firstIndex] &&
                      this.props.categories[this.state.firstIndex].relations &&
                      this.props.categories[this.state.firstIndex].relations[this.state.secondIndex] &&
                      this.props.categories[this.state.firstIndex].relations[this.state.secondIndex].relations[this.state.thirdIndex] &&
                      this.props.categories[this.state.firstIndex].relations[this.state.secondIndex].relations[this.state.thirdIndex].relations
                  ) || []}
                  onSortEnd={({ oldIndex, newIndex }) => this.onSortEnd({ col: 4, oldIndex, newIndex })}
                  onClick={this.handleClick}
                  onEdit={this.onEdit}
                  onDelete={this.onDelete}
                  onCreate={this.onCreate}
                  activeIndex={null}
                  parentIndex={
                    this.props.categories[this.state.firstIndex] &&
                    this.props.categories[this.state.firstIndex].relations &&
                    this.props.categories[this.state.firstIndex].relations[this.state.secondIndex] &&
                    this.props.categories[this.state.firstIndex].relations[this.state.secondIndex].relations[this.state.thirdIndex] &&
                    this.props.categories[this.state.firstIndex].relations[this.state.secondIndex].relations[this.state.thirdIndex].id
                  }
                  useDragHandle
                />
              }
            </div>
            <span style={{ display: 'hidden' }}>{this.state.col}</span>
          </div>
          {/* <pre>{JSON.stringify(this.state, null, 2)}</pre> */}
        </Card>
        <Modal
          title={`${this.state.formData.label ? this.state.formData.label : 'Категори нэмэх'}`}
          visible={this.state.formModal}
          onOk={this.formSubmit}
          width={800}
          onCancel={this.formCancel}
          footer={false}
        >
          {
            this.state.formModal ?
              <Form
                form={this.getFormOption()}
                data={this.state.formData}
                dataParams={{ body: { id: this.state.formData.id } }}
                delete={() => this.onDelete({
                  item: this.state.formData,
                  col: this.state.col,
                  idx: this.state.thirdIndex ? this.state.thirdIndex : (this.state.secondIndex ? this.state.secondIndex : this.state.firstIndex),
                })}
                notDeletable={this.state.formData.count !== 0}
                onSubmit={this.categorySubmit}
                validate={this.validate}
              /> : null
          }
        </Modal>
      </PageHeaderLayout>
    );
  }
}

const mapStateToProps = state => ({
  categories: state.category.all.list,
  thisCat: state.category.current,
});

const mapDispatchToProps = {
  loadCategory: Category.all,
  changeOrder: Category.changeOrder,
  changeOrderAsync: Category.order,
  create: Category.create,
  update: Category.update,
  delete: Category.delete,
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryList);




// WEBPACK FOOTER //
// ./src/containers/Categories/List/index.js